import {createContext, PropsWithChildren, useContext, useMemo, useState} from "react";
import {useQueryParam} from "../pricing/QueryParam";
import {HeaderToggleButton} from "../../shopdrawing/HeaderToggleButton";
import TableRowsIcon from "@mui/icons-material/TableRows";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export type ViewMode = "default" | "by-opening"

export const HardwareViewModeContext = createContext({
    viewMode: "default" as ViewMode,
    setViewMode: (mode: ViewMode) => {},
    showByUsSuppliers: false,
    setShowByUsSuppliers: (show: boolean) => {},
    phaseFilter: [] as string[],
    setPhaseFilter: (phases: string[]) => {},
    // the phases of the openings on screen; set by WorkingHardware
    phaseOptions: [] as string[],
    setPhaseOptions: (phases: string[]) => {},
})

export function HardwareViewModeProvider(props: PropsWithChildren<{}>) {
    const [viewMode, setViewMode] = useQueryParam("hwViewMode", "default");
    const [showByUs, setShowByUs] = useQueryParam("hwShowByUs", "false");
    const [phases, setPhases] = useQueryParam("hwPhases", "", {replace: true});
    const [phaseOptions, setPhaseOptions] = useState<string[]>([]);

    const ctx = useMemo(() => {
        return {
            viewMode: viewMode as ViewMode,
            setViewMode: setViewMode as any,
            showByUsSuppliers: showByUs === "true",
            setShowByUsSuppliers: (show: boolean) => setShowByUs(show ? "true" : "false"),
            phaseFilter: phases ? phases.split(",") : [],
            setPhaseFilter: (list: string[]) => setPhases(list.join(",")),
            phaseOptions,
            setPhaseOptions,
        }
    }, [viewMode, setViewMode, showByUs, setShowByUs, phases, setPhases, phaseOptions])

    return (
        <HardwareViewModeContext.Provider value={ctx}>
            {props.children}
        </HardwareViewModeContext.Provider>
    )
}

export function HardwareViewMode() {
    const ctx = useContext(HardwareViewModeContext);
    const active = ctx.viewMode === "by-opening";

    return (
        <HeaderToggleButton
            label="By Opening"
            icon={active ? <MeetingRoomOutlinedIcon fontSize="inherit" /> : <TableRowsIcon fontSize="inherit" />}
            active={active}
            onClick={() => ctx.setViewMode(active ? "default" : "by-opening")}
        />
    )
}

export function ShowByUsSuppliers() {
    const ctx = useContext(HardwareViewModeContext);
    const active = ctx.showByUsSuppliers;

    return (
        <HeaderToggleButton
            label="Show By-Us"
            icon={active ? <VisibilityIcon fontSize="inherit" /> : <VisibilityOffIcon fontSize="inherit" />}
            active={active}
            onClick={() => ctx.setShowByUsSuppliers(!active)}
        />
    )
}
